import { faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import Image from 'next/image'
import { IMAGE_BLUR_URL } from '../../utils/constants'
import Icon from '../Icon'
import SolidLine from '../SolidLine'
import style from '../../styles/components/author/author'

const SocialIcons = ({ twitter, email, linkedin }) => (
  <>
    {twitter && (
      <a href={twitter} target='_blank' rel='noreferrer'>
        <Icon icon={faXTwitter} size='sm' />
      </a>
    )}
    {email && (
      <a href={`mailto:${email}`}>
        <Icon icon={faEnvelope} size='sm' />
      </a>
    )}
    {linkedin && (
      <a href={linkedin} target='_blank' rel='noreferrer'>
        <Icon icon={faLinkedin} size='sm' />
      </a>
    )}
    <style jsx>{style}</style>
  </>
)

const AuthorHeader = ({ author }) => {
  const { avatar, byline, twitter, email, linkedin, bio } = author

  return (
    <>
      <div className='author-container'>
        <div className='author-header'>
          <div className='avatar'>
            <Image
              src={avatar?.url}
              width={avatar?.width}
              height={avatar?.height}
              layout='responsive'
              objectFit='contain'
              placeholder='blur'
              blurDataURL={IMAGE_BLUR_URL}
              alt={byline}
            />
          </div>
          <div className='byline-container'>
            <span>{byline}</span>
            <div className='icons'>
              <SocialIcons twitter={twitter} email={email} linkedin={linkedin} />
            </div>
          </div>
          <div className='bio'>{bio}</div>
        </div>
        <SolidLine />
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default AuthorHeader
